import { Spinner, makeStyles, tokens } from '@fluentui/react-components';
import type { CateringService } from '../services/cateringService';
import type { MeetingService } from '../services/meetingService';
import { useMeeting } from '../hooks/useMeeting';
import OrderFlow from './OrderFlow';
import UnavailablePage from './UnavailablePage';

const useStyles = makeStyles({
  loading: {
    display: 'flex',
    justifyContent: 'center',
    paddingTop: tokens.spacingVerticalXXL,
  },
});

export type MeetingGateProps = {
  meetingService: MeetingService;
  cateringService: CateringService;
};

export default function MeetingGate({ meetingService, cateringService }: MeetingGateProps) {
  const styles = useStyles();
  const state = useMeeting(meetingService);

  if (state.status === 'loading') {
    return (
      <main className={styles.loading}>
        <Spinner label="Loading meeting details" />
      </main>
    );
  }

  if (state.status === 'unavailable' || state.status === 'error') {
    return <UnavailablePage message={state.message} />;
  }

  return <OrderFlow meeting={state.meeting} cateringService={cateringService} />;
}
